<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Loaders
 * Name: LoaderFullScreenDomain
 * FIGMA: https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=22864-75
 */
import { LoaderFullScreen } from '@brighterly/lib-lumee-ui'

import { useAppBrand } from '@composables/tools/app-brand.hook'

import { LoaderSmartestMinds } from '@UI/Loaders/LoaderSmartestMinds'

defineOptions({
  name: 'LoaderFullScreenDomain',
})

const { isSmartestMinds } = useAppBrand()
</script>

<template>
  <Teleport
    v-if="isSmartestMinds"
    to="body"
  >
    <div class="loader-full-screen-domain">
      <LoaderSmartestMinds view="inverse" />
    </div>
  </Teleport>
  <LoaderFullScreen v-else />
</template>

<style lang="scss" scoped src="../styles/_loader-full-screen-domain.scss" />
